import { AxiosHttpClient } from './AxiosHttpClient';
import { HttpClient } from './HttpClient';

export const httpClient: HttpClient = new AxiosHttpClient({
  headers: {
    'Shippo-Api-Version': '2018-02-08',
  },
});
